import { render, staticRenderFns } from "./MagicBlockExt.vue?vue&type=template&id=64ab1bd5&scoped=true"
import script from "./MagicBlockExt.vue?vue&type=script&lang=ts"
export * from "./MagicBlockExt.vue?vue&type=script&lang=ts"
import style0 from "./MagicBlockExt.vue?vue&type=style&index=0&id=64ab1bd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ab1bd5",
  null
  
)

export default component.exports